"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../utils/documents");

var _arrays = require("../../utils/arrays");

var _utils = require("./utils");

var _MultiProjectChips = _interopRequireDefault(require("./MultiProjectChips"));

var _jsxRuntime = require("react/jsx-runtime");

function getDossierName(dossier) {
  var dossierName;

  switch (dossier.type) {
    case 'BUSINESS':
      dossierName = _reactReduxI18n.I18n.t("dossier.labels.BUSINESS.".concat(dossier.business));
      break;

    case 'PROJECT':
    case 'PROJECT_SHARED':
      dossierName = dossier.project.name;
      break;

    case 'RELATIONSHIP':
      dossierName = dossier.client.fullName;
      break;

    case 'ADDITIONAL':
      dossierName = null;
      break;

    default:
      dossierName = _reactReduxI18n.I18n.t('dossier.labels.LEGAL');
  }

  return dossierName;
}

function getProjectChip(dossiers) {
  if ((0, _arrays.isEmpty)(dossiers)) {
    return null;
  }

  return dossiers.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MultiProjectChips.default, {
    dossiers: dossiers
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    style: {
      color: _utils.chipColors.PROJECT,
      maxWidth: 300
    },
    className: "ellipsis chip m-2",
    title: dossiers[0].project.name,
    children: dossiers[0].project.name
  });
}

function getNonProjectChips(dossiers) {
  return dossiers.flatMap(function (dossier, index) {
    var dossierName = getDossierName(dossier);

    if (!dossierName) {
      return [];
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        color: _utils.chipColors[dossier.type],
        maxWidth: 300
      },
      className: "ellipsis chip m-2",
      title: dossierName,
      children: dossierName
    }, dossiers.length + index);
  });
}

function DocumentDossierChips(props) {
  var _props$dossiers$reduc = props.dossiers.reduce(function (acc, curr) {
    if (curr.type === 'PROJECT') {
      acc[0].push(curr);
    } else {
      acc[1].push(curr);
    }

    return acc;
  }, [[], []]),
      _props$dossiers$reduc2 = (0, _slicedToArray2.default)(_props$dossiers$reduc, 2),
      projectDossiers = _props$dossiers$reduc2[0],
      nonProjectDossiers = _props$dossiers$reduc2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "inline-container",
    children: [getProjectChip(projectDossiers), getNonProjectChips(nonProjectDossiers)]
  });
}

DocumentDossierChips.propTypes = {
  dossiers: _propTypes.default.arrayOf((0, _documents.documentDossierPropTypes)()).isRequired
};
var _default = DocumentDossierChips;
exports.default = _default;
//# sourceMappingURL=DocumentDossierChips.js.map